export enum FwdRollRowType {
  ORDER,
  DEALT,
  CURRENCY,
}

export namespace FwdRollRowType {
  let elements = [FwdRollRowType.ORDER, FwdRollRowType.DEALT, FwdRollRowType.CURRENCY];
  let alias = "com.bcdfx.model.enums.FwdRollRowType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
